import { NavigationSidebar, Flex } from '@taxbit-private/cosmic'
import styled from 'styled-components'

import { useLeftRailItems } from './useLeftRailItems'

const LeftRail = () => {
  const leftRailItems = useLeftRailItems()

  return (
    <LeftRailContainer>
      <NavigationSidebar sections={[{ items: leftRailItems }]} />
    </LeftRailContainer>
  )
}

export default LeftRail

const LeftRailContainer = styled(Flex)`
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
  display: grid;
`
